import React from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'

import CounterButton from '../CounterButton/CounterButton'
import Select from '../select/Select'
import '../../styles/scss/elements/room.scss';

const CHILD_AGES = [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17]
const MAX_OCCUPANCY = 4

const Room = ({ room, roomNumber, updateRoom }) => {
  function onAddAdult() {
    const adults = _.get(room, 'adults', [])
    const children = _.get(room, 'children', [])
    const totalOccupancy = adults.length + children.length
    if (totalOccupancy < MAX_OCCUPANCY) {
      updateRoom(
        {
          adults: _.concat(adults, ['A']),
          children,
        },
        roomNumber - 1
      )
    }
  }

  function onRemoveAdult() {
    const adults = _.get(room, 'adults', [])
    if (adults.length > 1) {
      const updatedRoom = {
        adults: _.take(adults, adults.length - 1),
        children: _.get(room, 'children', []),
      }
      updateRoom(updatedRoom, roomNumber - 1)
    }
  }

  function onAddChild() {
    const adults = _.get(room, 'adults', [])
    const children = _.get(room, 'children', [])
    const totalOccupancy = adults.length + children.length
    if (totalOccupancy < MAX_OCCUPANCY && children.length < 2) {
      const updatedRoom = {
        adults,
        children: _.concat(children, [2]),
      }
      updateRoom(updatedRoom, roomNumber - 1)
    }
  }

  function onRemoveChild() {
    const children = _.get(room, 'children', [])
    if (children.length) {
      const updatedRoom = {
        adults: _.get(room, 'adults', []),
        children: _.take(children, children.length - 1),
      }
      updateRoom(updatedRoom, roomNumber - 1)
    }
  }

  function onUpdateChildAge(age, index) {
    const children = _.get(room, 'children', [])
    children[index] = age
    const updatedRoom = {
      adults: _.get(room, 'adults', []),
      children,
    }
    updateRoom(updatedRoom, roomNumber - 1)
  }

  return (
    <div className="room-wrapper">
      <h2 className="room-wrapper__heading" aria-label={`Room ${roomNumber}`}>
        Room {roomNumber}
      </h2>
      <div className="u-flex room-wrapper__content">
        <div className="u-flex u-flex-column u-flex-space-between room-wrapper__content__left-side">
          <div
            className="room-wrapper__content__left-side__travellers"
            aria-label="How many travellers"
          >
            <span className="info-indicator">*</span> How many travellers?
          </div>
          <div
            className="room-wrapper__content__left-side__required-field"
            aria-label="Denotes a required field"
          >
            <span className="info-indicator">*</span> Denotes a required field
          </div>
        </div>
        <div className="u-flex u-flex-column room-wrapper__right-side">
          <div
            className="u-flex u-flex-space-between room-wrapper__right-side__items"
            aria-label="Adults (Age 13+)"
          >
            <p className="price-heading">Adults (Age 13+)</p>
            <CounterButton
              value={_.get(room, 'adults', []).length}
              addCounter={onAddAdult}
              subCounter={onRemoveAdult}
            />
          </div>
          <div className="u-flex u-flex-space-between room-wrapper__children room-wrapper__right-side__items">
            <div
              className="ylg-agent-portal__Pricing__passenger-details__heading__children"
              aria-label="Children (Age2-12)"
            >
              <p className="price-heading">Children (Age 2-12)</p>
            </div>
            <CounterButton
              value={_.get(room, 'children', []).length}
              addCounter={onAddChild}
              subCounter={onRemoveChild}
            />
          </div>
          <div className="u-flex room-wrapper__children__count">
            <div className="u-flex room-wrapper__children__count__right">
              {_.map(_.get(room, 'children', []), (childAge, index) => (
                <div
                  key={`${index}`}
                  className="u-flex-space-between child"
                  aria-label={`Child ${index + 1}`}
                >
                  <p className="price-heading">Child {index + 1}</p>
                  <Select
                    onChange={(event) =>
                      onUpdateChildAge(Number(event.target.value), index)
                    }
                    options={_.map(CHILD_AGES, (option) => ({
                      value: `${option}`,
                      displayName: `${option}`,
                    }))}
                    className="room-wrapper__children__count__select"
                    value={`${childAge}`}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

Room.prototype = {
  number: PropTypes.number.isRequired,
}

export default Room
